import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const useEmptyStateContentStyles = makeStyles({
  container: {
    boxSizing: 'border-box',
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL, tokens.spacingVerticalM, tokens.spacingHorizontalL),
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  'title-largeSurface': {
    ...typographyStyles.subtitle1,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin('0'),
  },
  'subtext-largeSurface': {
    ...typographyStyles.caption1,
    color: tokens.colorNeutralForeground3,
    marginBottom: 0,
  },
  'title-mediumSurface': {
    ...typographyStyles.subtitle2,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin('0'),
  },
  'subtext-mediumSurface': {
    ...typographyStyles.caption1,
    color: tokens.colorNeutralForeground3,
    marginBottom: 0,
  },
  'title-mediumMenu': {
    ...typographyStyles.body1Strong,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin('0'),
  },
  'subtext-mediumMenu': {
    ...typographyStyles.caption2,
    color: tokens.colorNeutralForeground3,
    marginBottom: 0,
  },
  'title-smallMenu': {
    ...typographyStyles.caption2Strong,
    color: tokens.colorNeutralForeground1,
    ...shorthands.margin('0'),
  },
  'subtext-smallMenu': {
    ...typographyStyles.caption2,
    color: tokens.colorNeutralForeground3,
    marginBottom: 0,
  },
});
